import { render, staticRenderFns } from "./OpportunityCard.vue?vue&type=template&id=48b5661d&scoped=true&"
import script from "./OpportunityCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityCard.vue?vue&type=style&index=0&id=48b5661d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5661d",
  null
  
)

export default component.exports